const AddressComponentType = {
  StreetNumber: 'street_number',
  Route: 'route',
  Locality: 'locality',
  Political: 'political',
  FirstAdministrativeAreaLevel: 'administrative_area_level_1',
  SecondAdministrativeAreaLevel: 'administrative_area_level_2',
  Country: 'country',
  PostalCode: 'postal_code',
};

const AddressComponentFormattingType = {
  LongName: 'long_name',
  ShortName: 'short_name',
};

export default class AddressComponentParseService {
  static parseComponentsToAddressObject(components) {
    return {
      street: this.#getStreet(components),
      area: this.#getArea(components),
      streetNumber: this.#getStreetNumber(components),
      city: this.#getCity(components),
      state: this.#getState(components),
      country: this.#getCountry(components),
      postalCode: this.#getPostalCode(components),
    };
  }

  static #getStreet(components) {
    return this.#getComponentByType(
      components,
      AddressComponentType.Route,
      AddressComponentFormattingType.LongName,
    );
  }

  static #getStreetNumber(components) {
    return this.#getComponentByType(
      components,
      AddressComponentType.StreetNumber,
      AddressComponentFormattingType.LongName,
    );
  }

  static #getCity(components) {
    return this.#getComponentByType(
      components,
      AddressComponentType.Locality,
      AddressComponentFormattingType.LongName,
    );
  }

  static #getState(components) {
    return this.#getComponentByType(
      components,
      AddressComponentType.FirstAdministrativeAreaLevel,
      AddressComponentFormattingType.ShortName,
    );
  }

  static #getCountry(components) {
    return this.#getComponentByType(
      components,
      AddressComponentType.Country,
      AddressComponentFormattingType.ShortName,
    );
  }

  static #getPostalCode(components) {
    const postalCode = this.#getComponentByType(
      components,
      AddressComponentType.PostalCode,
      AddressComponentFormattingType.LongName,
    );

    return postalCode?.replace(/ /g, '');
  }

  static #getArea(components) {
    return this.#getComponentByType(
      components,
      AddressComponentType.SecondAdministrativeAreaLevel,
      AddressComponentFormattingType.LongName,
    );
  }

  static #getComponentByType(components, type, formattingType) {
    const componentByType = components.find((component) => component.types.includes(type));

    return componentByType?.[formattingType];
  }
}
